import React from 'react';
import classNames from 'classnames';
import * as styles from './TextButton.module.scss';

type Props = {
  color?: 'green';
  className?: string;
  onClick?: (event?: React.MouseEvent) => void;
};

export default function TextButton({ className, children, color, onClick }: React.PropsWithChildren<Props>) {
  const colorClassName = color && styles[color];
  return (
    <button className={classNames(styles.button, className, colorClassName)} onClick={onClick} type="button">
      {children}
    </button>
  );
}
